import makeStyles from '@mui/styles/makeStyles';
import { COLORS } from 'constants/styles';

export default makeStyles(
  {
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      cursor: 'pointer',
      color: COLORS.white,
      fontSize: 20,
      fontWeight: 500,
      backgroundColor: '#348AEB',
      border: `2px solid ${COLORS.white}`,
      borderRadius: 8,
      padding: '16px 20px',
      paddingBottom: 12,

      '&:hover': {
        border: `2px solid ${COLORS.hover}`,
        backgroundColor: COLORS.hover,
      },

      '&:active': {
        border: `2px solid ${COLORS.clicked}`,
        backgroundColor: COLORS.clicked,
      },
    },

    disabled: {
      border: `2px solid ${COLORS.lightGray}`,
      backgroundColor: COLORS.lightGray,
      color: COLORS.textGray,

      '&:active, &:hover': {
        border: `2px solid ${COLORS.lightGray}`,
        backgroundColor: COLORS.lightGray,
        color: COLORS.textGray
      },
    },

    fullWidth: {
      width: '100%',
    },
  },
  { name: 'Button' },
);
